/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.FullNameValidator = class FullNameValidator {
  constructor(fullName, minLength) {
    this.fullName = fullName;
    if (minLength == null) { minLength = 4; }
    this.minLength = minLength;
  }

  isValid() {
    const stripped = $.trim(this.fullName);
    return stripped.length >= this.minLength;
  }
};
